import type { ReactElement } from "react";

/**
 * The pill key's face while a typed send waits for a file (spec 2026-09-24,
 * Part B; the look is the approved mockups/file-ask-card-2026-09-24.html): a
 * turning ring and "Uploading". The key keeps its seat and its box; only what
 * it reads changes. Its aria-label and title name the file it waits for.
 */
export function UploadingFace(): ReactElement {
  return (
    <>
      <svg
        className="h-3.5 w-3.5 flex-none animate-spin-1 motion-reduce:animate-none"
        viewBox="0 0 16 16"
        aria-hidden="true"
        data-testid="uploading-ring"
      >
        <circle
          cx="8"
          cy="8"
          r="6"
          fill="none"
          stroke="currentColor"
          strokeOpacity="0.35"
          strokeWidth="2"
        />
        <path
          d="M8 2a6 6 0 0 1 6 6"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
      Uploading
    </>
  );
}

/**
 * What the Delegate key reads, on home and on a task's screen alike (one face,
 * named once, so the two keys can never drift): "↵ Delegate", or the Uploading
 * face while a file the send would carry is still uploading.
 */
export function DelegateFace({
  waitReason,
}: {
  waitReason: string | undefined;
}): ReactElement {
  if (waitReason) return <UploadingFace />;
  return (
    <>
      <b className="font-mono text-3 font-semibold text-gold-molten-hi">↵</b>{" "}
      Delegate
    </>
  );
}
